__turbopack_context__.v({
  "imageContainer": "vsM_FW_imageContainer",
  "imageContainerAspectRatio": "vsM_FW_imageContainerAspectRatio",
});
